<!-- Migrated from legacy/Plus/Plus/2014/Events/index.shtml (Masterclass section) -->

<template>
  <h3>
    <span style="font-weight: 200">'Unlocking the Protein Data Bank': A Masterclass with David
      Goodsell</span>
  </h3>
  <h4>8:30&ndash;11am, Friday 30 May 2014 &mdash; Museum of Contemporary Art, Sydney</h4>
  <p>
    In this Data Visualization Masterclass &mdash; a companion to the
    <router-link to="/2014/Showcase/MakingScienceBeautiful">'Making Science Beautiful'</router-link>
    evening &mdash; participants learned from one of the world's leading biomedical artists how
    to discover the creative potential that lies within cell walls.
  </p>
  <a href="/Showcase/2014/DGoodsell-portrait_large.jpg" title="David Goodsell">
    <img
      class="portrait right"
      src="/Showcase/2014/DGoodsell-portrait_small.jpg"
      alt="Portrait of David Goodsell" />
  </a>
  <p>
    David unpacked the processes and challenges of working at a molecular and cellular scale, and
    explored the tensions between artistic licence and scientific research in the world of
    molecular visualisation. Through hands-on exercises, participants were introduced to the
    Protein Data Bank and learned to use JSMol tools to customise images highlighting different
    aspects of molecular structure and function. Participants left with a new appreciation of
    proteins, and a new set of skills to aid scientific communication and artistic
    experimentation.
  </p>
</template>

<style scoped>
h3 {
  display: inline;
}
h4 {
  font-weight: 600;
  font-size: 1rem;
  margin-top: 1.5rem;
  clear: both;
}
img.portrait {
  max-width: 35%;
  border-radius: 4px;
}
img.right {
  float: right;
  margin: 0 0 1rem 1.5rem;
}
</style>
